<template>
  <div class="itemLink">
    <div class="itemLink__column--left">
      <strong>Functie</strong>
      {{ rate.function_name }}
    </div>

    <div class="itemLink__column--middle">
      <strong>Incidenteel</strong>
      {{ formatPriceToEuroString(rate.rate) }}
    </div>

    <div class="itemLink__column--right">
      <strong>Periodiek</strong>
      {{ formatPriceToEuroString(rate.periodical_rate) }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatPriceToEuroString } from '@pidz/utils';


defineProps<{
  rate: Rate;
}>();
</script>

<style lang="scss" scoped>
.itemLink {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 0;

  &__column--left,
  &__column--middle,
  &__column--right {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
  }

  &__column--left {
      flex: 2;

      @media only screen and (min-width: 768px) {
        flex: 3;
      }
    }
}
</style>
